// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"dafe44ac","759":"1633ecc4","901":"9ca666a7"}[chunkId] + ".chunk.css";
};